<template>
    <div :id="`${facetKey}-${renderVersion}`" v-if="showFacet">
        <div class="facet-header">
            <button class="toggle-header-button"
                    v-on:click="toggleFacetList"
                    role="button"
                    :aria-expanded="`${visibleList}`"
                    :aria-controls="`${facetKey}-options`"
                    :aria-label="`${i18n_strings.aria_toggle_facet} ${facetName}`">
                <p role="heading" aria-level="2">{{facetName}}</p>
                <PlusIcon v-if="!visibleList"/>
                <MinusIcon v-if="visibleList"/>
            </button>
        </div>
        <div :id="`${facetKey}-options`" role="region" class="facet-list" v-if="visibleList">
            <fieldset>
                <legend class="visually-hidden">{{i18n_strings.facet_instructions}} {{facetName}}</legend>
                <ul class="facet-options">
                    <li class="facet-option" v-for="option in facetOptions" :key="option.key">
                        <input type="checkbox"
                            v-on:click="toggleFacetSelection"
                            :checked="isSelected(option.key)"
                            :id="uniqueID(option.key)"
                            :aria-labelledby="`${uniqueID(option.key)}-label`"
                            :value="option.key"
                            :category="facetKey">
                        <label :for="uniqueID(option.key)" :id="`${uniqueID(option.key)}-label`" class="vertically-challenged-facet">
                            {{option.key}} ({{option.doc_count}}<span class="visually-hidden"> {{i18n_strings.aria_results}}</span>)
                        </label>
                    </li>
                </ul>
            </fieldset>
        </div>
    </div>
</template>

<style lang="scss">
.facet-header {
    border-top: .0625rem solid rgba(35,35,35,.5);

    button {
        border: none;
        background: none;
        width: 100%;
        padding: 0;
        position: relative;

        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-justify-content: space-between;
        justify-content: space-between;
        -webkit-align-items: center;
        align-items: center;

        p {
            margin: .7rem 0;
        }

        svg {
            display: block;
            margin-left: 1rem;
            position: absolute;
            right: 0;
            top: 18px;
        }

        &:focus {
            transition: none;
            outline: .0625rem dashed #000;
            outline-offset: .3125rem;
        }
    }
}
@media screen and (max-width: 900px) {
    .facet-header {
        padding: 0 1rem;
    }

}

.facet-list {

    fieldset {
        border: none;
        padding: 0;
    }

    .facet-options {
        list-style-type: none;
        padding: 0;
        margin-top: 0;

        .facet-option {
            padding: 0;
            margin-bottom: 0;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: start;
            -ms-flex-align: start;
            align-items: flex-start;

            input[type="checkbox"] {
                margin-right: .5rem;
                margin-top: 6px;

                appearance: none;
                height: 16px;
                width: 16px;
                border: solid 1px #968c82;
                -ms-flex-negative: 0;
                flex-shrink: 0;

                &:checked {
                    background-image: url(../../assets/checkedBox.svg);
                    background-position: -0.5px -0.8px;
                }
            }
        }
    }

    @media screen and (max-width: 900px) {
        .facet-options {
            padding-left: 0.9rem;
        }
    }
}
</style>

<script>
import PlusIcon from "@/components/icons/PlusIcon";
import MinusIcon from "@/components/icons/MinusIcon";
import { mapGetters } from "vuex";


export default {
    name: 'FacetList',
    components: {
        PlusIcon,
        MinusIcon
    },
    props: {
        "facetOptions": Array,
        "facetKey": String,
        "facetName": String,
        "renderVersion": Number
    },
    data: function() {
        return {
            visibleList: false,
            facetTracker: {}
        }
    },
    computed: {
        ...mapGetters([
            'i18n_strings',
            'searchSelectedFacets'
        ]),
        showFacet: function() {
            return this.facetOptions && this.facetOptions.length > 0;
        }
    },
    methods: {
        toggleFacetList: function() {
            this.visibleList = !this.visibleList;
        },
        toggleFacetSelection: function(event) {
            const facet = {
                category: event.target.getAttribute("category"),
                facet: event.target.value
            }

            if (event.target.checked) {
                this.$emit('addFacet', facet);
            } else {
                this.$emit('removeFacet', facet);
            }
        },
        isSelected: function(facet) {
            const justFacetNames = this.searchSelectedFacets ? this.searchSelectedFacets
                .filter(item => item['category'] === this.facetKey)
                .reduce((onlyFacets, next) => { return onlyFacets.concat(decodeURI(next.facet)) }, []) : [];

            return justFacetNames.includes(facet);
        },
        uniqueID: function(text) {
            return `${this.facetKey.substr(0,3)}-${text.toLowerCase().replace(/ /g, '-')}`;
        }
    }
}
</script>